import { useQuery } from "@tanstack/react-query";
import { getWidgetNotifications } from "@/services/v2/widgetService";

// Notifications are decoration: a failure must never break the widget, so
// errors resolve to an empty list and nothing retries.
export const fetchWidgetNotifications = async (widgetKey) => {
  try {
    const res = await getWidgetNotifications(widgetKey);
    if (res?.errorCode !== 0) return [];
    return res.result?.notifications ?? [];
  } catch {
    return [];
  }
};

const useWidgetNotifications = (widgetKey, enabled = true) =>
  useQuery({
    queryKey: ["widgetNotifications", widgetKey],
    enabled: !!widgetKey && enabled,
    retry: false,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    queryFn: () => fetchWidgetNotifications(widgetKey),
  });

export default useWidgetNotifications;
